import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-layout',
  templateUrl: './file-layout.component.html',
  styleUrls: ['./file-layout.component.scss'],
})
export class FileLayoutComponent {
  @Input('fileName') title: string = '';
  @Input('fileSize') size: string = '';
  @Input('link') _link: string = '';

  get link() {
    return `${this._link}`;
  }
  @Output('handleClick') handleClick = new EventEmitter<{
    title: string;
    link: string;
  }>();
}
